var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.667 8.667V12c0 .367-.3.667-.667.667H4A.669.669 0 013.333 12V8.667c0-.367-.3-.667-.666-.667C2.3 8 2 8.3 2 8.667v4C2 13.4 2.6 14 3.333 14h9.334C13.4 14 14 13.4 14 12.667v-4C14 8.3 13.7 8 13.333 8c-.366 0-.666.3-.666.667zm-4-.22L9.92 7.193a.664.664 0 11.94.94l-2.393 2.394c-.26.26-.68.26-.94 0L5.133 8.133a.664.664 0 11.94-.94l1.26 1.254v-5.78C7.333 2.3 7.633 2 8 2c.367 0 .667.3.667.667v5.78z"
  })));
}
export default SvgExport;